// for handler static data, not include db, api, socket..

let md5 = require('md5');
const _ = require('lodash');
const crypto = require('crypto');

function guid () {
    return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
    );
}

function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

//convert date to string format yyyy/MM/dd HH:mm:ss
function convertDate (date) {
    var dformat = [date.getFullYear(),
            pad2NumberString((date.getMonth() + 1).toString()),
            pad2NumberString((date.getDate()).toString())].join('/') +
        ' ' +
        [pad2NumberString((date.getHours().toString())),
            pad2NumberString((date.getMinutes().toString())),
            pad2NumberString((date.getSeconds().toString()))].join(':');

    return dformat
}

//Padleft number string format 00
function pad2NumberString (str) {
    var strTemp = '00' + str;
    return strTemp.substring(str.length)
}

function checkStringIsUrl (str) {
    if (str) {
        var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
        return regexp.test(str);
    }
}

function htmlEntities (str) {
    return String(str).replace(/&(?!(nbsp;))/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const utils = {
    generateSubscribe (botCode, senderId, channel) {
        // md5<sender_id.bot_code>@bot_code/channel
        let encryptString = md5(senderId + '.' + botCode);
        return encryptString + '@' + botCode + '/' + channel
    },

    render_random_id () {
        return guid()
    },

    convertDateString (date) {
        return convertDate(date);
    },

    urlify (text) {
        text = htmlEntities(text);
        if (checkStringIsUrl(text)) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function (url) {
                return '<a rel="noopener" style="position: relative; display: inline; width: 100%; word-break: break-all;" target="_blank" href="' + url + '">' + (url) + '</a>';
            });
        } else {
            return text;
        }
    },
    buildSLAQuery (agent_email, duration, fromDate, toDate, page, page_size, sortBy, descending) {
        let query = '';
       
        if (agent_email) {
            query = query + '&agent_email=' + agent_email
        }
        if (duration) {
            query = query + '&duration=' + duration
        }
        if (page) {
            query = query + '&page=' + page
        }
        if (page_size) {
            query = query + '&page_size=' + page_size
        }
       
        if (fromDate && toDate) {
            query = query + '&from_date=' + fromDate + '&to_date=' + toDate
        }
        if(sortBy){
            sortBy = descending ? '-' + sortBy : sortBy
            query = query + '&sort=' + sortBy
        }
        return query;
    },
    buildQuery (channel, search, agent_email, search_type, type, skills, is_long_wait,advance_filter,fromDate, toDate, page, page_size) {
        let query = '';
        if (channel) {
            query = query + '&channel=' + channel
        }
        if (search) {
            query = query + '&search=' + search
        }
        if (agent_email) {
            query = query + '&agent_email=' + agent_email
        }
        if (page) {
            query = query + '&page=' + page
        }
        if (page_size) {
            query = query + '&page_size=' + page_size
        }
        if (search_type !==undefined) {
            query = query + '&search_type='+ search_type
        }
        if (type) {
            query = query + '&type=' + type
        }
        if (is_long_wait===true) {
            query = query + '&is_long_wait=true'
        }
        if (skills && skills.length > 0) {
            query = query + '&skills='+skills
        }
        if (advance_filter) {
            query = query + '&advance_filter=' + advance_filter
        }
        if (fromDate && toDate) {
            query = query + '&fromDate=' + fromDate.toISOString() + '&toDate=' + toDate.toISOString()
        }
        return query;
    },
    buildCrmQuery (properties, projection, page, page_size) {
        let query = '';
        if (properties) {
            let properties_string = ""
            let properties_keys = Object.keys(properties)
            for (const item in properties_keys){
                properties_string += properties_keys[item] + ":" + properties[properties_keys[item]] + "|"

            }
            query = query + '&properties=' + properties_string
        }
        if (projection) {
            let projection_string = "sender_id|"
            for (const item in projection){
                projection_string += projection[item] + "|"
            }
            query = query + '&projection=' + projection_string
        }
        if (page) {
            query = query + '&page=' + page
        }
        if (page_size) {
            query = query + '&page_size=' + page_size
        }

        return query;
    },
    smoothListChannels (channels) {
        channels.unshift('all');
        channels = _.map(channels, (channel) => {
            if (channel === 'old_livechat') {
                return 'livechat'
            } else return channel
        });
        return _.uniq(channels);
    },
    getBotIconName (name) {
        if (!name) {
            return ''
        }
        let iconName = ''
        name.split(' ').forEach(item => {
            iconName += item ? item.charAt(0).toUpperCase() : ''
        })
        if (iconName.length > 3) {
            return iconName.substring(0, 3)
        }
        return iconName
    },
    viewableMessageType: [
        "text",
        "image",
        "quick_reply",
        "payload",
        "carousel",
        "zalo_list_template",
        "file",
        "uploading",
        "email",
        "user_send_location",
        "request_users_location",
        "sticker",
        "rating"
    ],
    removeVietnameseTones(str) {
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y");
        str = str.replace(/đ/g,"d");
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
        str = str.replace(/Đ/g, "D");
        // Some system encode vietnamese combining accent as individual utf-8 characters
        // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
        str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
        // Remove extra spaces
        // Bỏ các khoảng trắng liền nhau
        str = str.replace(/ + /g," ");
        str = str.trim();
        // Remove punctuations
        // Bỏ dấu câu, kí tự đặc biệt
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
        return str;
    },
    hash(text) {
        return crypto.createHash('sha1').update(text).digest('hex');
    }
}

export default utils
